import type { RouteLocationNormalizedLoaded, RouteLocationRaw, Router } from 'vue-router';

const FOLDER_EXPLORER_SOURCE = 'folderExplorer';

const routeValueContainsFolderExplorerSource = (value: unknown): boolean => {
	if (Array.isArray(value)) {
		return value.includes(FOLDER_EXPLORER_SOURCE);
	}
	return value === FOLDER_EXPLORER_SOURCE;
};

export function routeHasFolderExplorerSource(route: RouteLocationNormalizedLoaded): boolean {
	return (
		routeValueContainsFolderExplorerSource(route.params.source) ||
		routeValueContainsFolderExplorerSource(route.query.source)
	);
}

export function folderExplorerReturnRoute(): RouteLocationRaw {
	return { name: 'organization' };
}

export function returnToFolderExplorer(router: Router): void {
	void router.push(folderExplorerReturnRoute());
}
